export const configAirportDh = {
  "data": {
    "Type": "GeoJSON",
    "url": "pri/data/AIRAC/%cycle_date%/airport/%customer%-airport.json",
    "update_interval": 0,
    "retain": true,
    "cache": true,
  }
}

export const configAirportLayer = {
  "Name": "Airport",
  "Renderer": "GeoJSON",
  "Attributes": {
    "features": [{
      "style": {
        "default": {
          "type": "point",
          "line_color": "#F4962C",
          "line_width": 1,
          "point_size": 10
        }
      }
    }]
  }
}